<div class="bg-theme-lightBlue3 rounded p-2 flex flex-col gap-2 text-theme-darkBlue w-60 max-w-full overflow-y-auto max-h-[410px]">
  @for (notification of notifications(); track notification.id) {
    <app-notification [notification]="notification"></app-notification>
  } @empty {
    <p class="text-center text-theme-gray">No hay notificaciones disponibles</p>
  }
</div>
